export default {
    common: {
        email: '电邮',
        LoginBtn: '登录',
        SignUpBtn: '注册',
        SubmitBtn: '提交',
        ExitBtn: '退出',
        LogoutBtn: '登出'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: '请于电邮内查收验证码',
        VerificationCode: '验证码'
    },
    header: {
        OrderHistory: '订单记录',
        MYACCOUNT: '我的账户',
        WelcomeBack: '欢迎回来'
    },
    detail: {
        TotalOrders: '订单总数',
        TotalProducts: '产品总数',
        WonderlandPoints: 'Wonderland积分',
        APMCredits: 'APM积分',
        ExpireOn: '有效期限',
        NoAPMCredits: '暂无APM积分',
        CreditsLoading: '积分加载中',
        Orders: '订单',
        Online: '网上商店',
        Boutique: '精品店',
        Total: '总计',
        Delivered: '已送达',
        NoData: '暂无数据',
        Status: '状态',
        item: '商品',
        items: '商品'
    },
    panel: {},
    entry: {
        Client: '顾客',
        OrderDate: '订单日期',
        DeliverDate: '送达日期',
        Description: '描述',
        Total: '合计'
    },
    board: {
        Order: '订单',
        Date: '日期',
        Total: '合计'
    },
    order: {
        OrderID: '订单编号',
        PurchasePlace: '购买地点',
        PurchaseDate: '购买日期',
        TotalPrice: '总价',
    },
    product: {
        Name: '商品名称',
        SKU: '商品SKU',
        Size: '商品尺码',
        Quantity: '商品数量',
        Price: '商品价格',
        WarrantyUntil: '保修期至',
    },
    ordersLayout: {
            pageTitleOrders: "订单",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "主页",
            navProfile: "个人资料",
            navOrders: "订单",
            navWonderland: "Wonderland",
            navWishlist: "愿望清单",
            navContactUs: "联系我们",
            navExchangeReturn: "换货与退货",
            footerExchangePolicy: "换货与退货政策",
            footerShipping: "配送",
            footerPrivacy: "隐私政策",
            footerTerms: "服务条款",
            footerRegion: "法国",
            menuTrackOrder: "追踪订单",
            menuViewDetails: "查看详情",
            back: "返回",
            orderNumberHeading: "订单编号 {{id}}",
            itemsCount_one: "{{count}} 件商品",
            itemsCount_other: "{{count}} 件商品",
            emptyOrders: "您还没有任何订单。",
            loading: "加载中",
            invoiceSoon: "即将推出",
            storeAddressPending: "地址稍后提供",
            skuPrefix: "SKU",
            statusLabel: "状态",
            productNameFallback: "商品",
            tabOnline: "线上",
            tabOffline: "线下",
            learnMore: "了解更多",
            redeemInStore: "到店兑换",
            dateLabel: "日期",
            itemSingular: "商品",
            statusConfirmed: "已确认",
            purchaseDateLabel: "购买日期：",
            monthJan: "1月",
            monthFeb: "2月",
            monthMar: "3月",
            monthApr: "4月",
            monthMay: "5月",
            monthJun: "6月",
            monthJul: "7月",
            monthAug: "8月",
            monthSep: "9月",
            monthOct: "10月",
            monthNov: "11月",
            monthDec: "12月",
            storeLabel: "门店",
            downloadInvoice: "下载发票",
            warrantyExpires: "保修期至",
            sizeLabel: "尺码",
            subtotalLabel: "小计",
            totalLabel: "合计",
            ecListTitle: "您的订单",
            ecStatusInStore: "状态：门店购买",
            ecOrderNumber: "订单编号：{{order_number}}",
            ecDateStore: "{{date}} · {{store_name}}",
            ecCountTotalOne: "{{count}} 件商品：合计 {{amount}}",
            ecCountTotalOther: "{{count}} 件商品：合计 {{amount}}",
            ecViewOrder: "查看订单 >",
            ecViewOrderA11y: "查看订单 {{order_number}}",
            ecBackToOrders: "返回您的订单",
            ecInStoreDate: "门店购买 – {{date}}",
            ecProductsOne: "商品",
            ecProductsOther: "商品",
            ecSku: "货号：{{sku}}",
            ecQty: "数量：{{qty}}",
            ecWarrantyExpired: "已过保修期",
            ecWarrantyActive: "保修期内",
            ecSubtotalOne: "小计 – {{count}} 件商品",
            ecSubtotalOther: "小计 – {{count}} 件商品",
        },
}



// WEBPACK FOOTER //
// ./src/locales/sc/index.js